import { isAfter, isBefore, isSameDay } from "date-fns";
import formatDate from "src/utils/formatDate";
import { IWdtba003 } from "../Config/interface";

const convertValue = (value:string|undefined,dataType:string) => {
	if (dataType === "D" && value) {
		return new Date(value);
	} if (dataType === "N") {
		return Number(value);
	}
	return value?.toString()?.toUpperCase()||"";
};

const dateFunctions = {
	isAfterOrEqual:(date:string | number | Date,testDate:string | number | Date) => 
		isAfter(date as Date,testDate as Date) || isSameDay(date as Date,testDate as Date),
	isBeforeOrEqual:(date:string | number | Date,testDate:string | number | Date) => 
		isBefore(date as Date,testDate as Date) || isSameDay(date as Date,testDate as Date)
};

const resolveRules = (data:any,column:IWdtba003,columns:IWdtba003[],currentLanguage:"pt"|"en"|"es") => {
    
	let valor:string|number|Date;
	let valorString:string = "";
	let style:string = "";
	let existColRule = false;
	column?.rules?.some((rule) => {
		existColRule = columns.some((x) => x.id === rule.refColumnId);
		if (existColRule) {
			return true;
		}
		return false;
	});

	// Se não tem regra de formatação, usa a própria coluna
	// caso tenha regra mas nenhuma coluna de referencia não esteja sendo exibida não usará a regra de formatação
	if ((!column.rules || !column.rules.length) || !existColRule) {
		valor = data[column.wda003Nomecoluna];
		valor = valor || valor === 0 ? convertValue(valor.toString(),column.wda003Tipocoluna) : "";
		valorString = valor.toString();
		if (column.wda003Tipocoluna === "D" && valor) {
			valor = new Date(valor);
			valorString = formatDate(new Date(valor),currentLanguage);
		} else if (column.wda003Tipocoluna === "N") {
			valor = +valor;
		}
	}

	column?.rules?.forEach((rule) => {
		let colref:IWdtba003|undefined = column;
		let valueRef:string|number|Date = valor;

		if(rule.refColumnId){
			colref = columns.find((wda003) => wda003.id === rule.refColumnId);
			if(colref)
			    valueRef = convertValue(data[colref.wda003Nomecoluna],colref.wda003Tipocoluna);
		}
		
		if (colref) {
			const wda011Valor = convertValue(rule.wda011Valor,colref.wda003Tipocoluna);
			const wda011Valorfim = convertValue(rule.wda011Valorfim,colref.wda003Tipocoluna);
			let aplicaFormatacoes = false;

			switch (rule.wda011Operador) {
			    
			case 1: // Igual
				if (colref.wda003Tipocoluna === "D") {
					aplicaFormatacoes = isSameDay(wda011Valor as Date,valueRef as Date);
				} else {
					aplicaFormatacoes = wda011Valor === valueRef;
				}
				break;
			case 2: // Diferente
				if (colref.wda003Tipocoluna === "D") {
					aplicaFormatacoes = !isSameDay(wda011Valor as Date,valueRef as Date);
				} else {
					aplicaFormatacoes = wda011Valor !== valueRef;
				}
				break;
			case 3: // Maior que
				if (colref.wda003Tipocoluna === "D") {
                    
					aplicaFormatacoes = isAfter(valueRef as Date, wda011Valor as Date);
				} else {
					aplicaFormatacoes = valueRef > wda011Valor;
				}
				break;
			case 4: // Menor que
				if (colref.wda003Tipocoluna === "D") {
					aplicaFormatacoes = isBefore(valueRef as Date, wda011Valor as Date);
				} else {
					aplicaFormatacoes = valueRef < wda011Valor;
				}
				break;
			case 5: // Maior ou igual
				if (colref.wda003Tipocoluna === "D") {
					aplicaFormatacoes = dateFunctions.isAfterOrEqual(valueRef,wda011Valor);
				} else {
					aplicaFormatacoes = valueRef >= wda011Valor;
				}
				break;
			case 6: // Menor ou igual
				if (colref.wda003Tipocoluna === "D") {
					aplicaFormatacoes = dateFunctions.isBeforeOrEqual(valueRef,wda011Valor);
				} else {
					aplicaFormatacoes = valueRef <= wda011Valor;
				}
				break;
			case 7: // Entre ... e ...
				if (colref.wda003Tipocoluna === "D") {
					aplicaFormatacoes = dateFunctions.isAfterOrEqual(valueRef,wda011Valor) && dateFunctions.isBeforeOrEqual(valueRef,wda011Valorfim);
				} else {
					aplicaFormatacoes = valueRef >= wda011Valor && valueRef <= wda011Valorfim;
				}
				break;
			case 8: // Na lista
				aplicaFormatacoes = String(wda011Valor).split(",").some((x) => x === String(valueRef).toUpperCase());
				break;
			case 9: // É nulo
				aplicaFormatacoes = !valueRef;
				break;
			case 10: // Contém
				aplicaFormatacoes = String(valueRef).toUpperCase().indexOf(wda011Valor as string) >= 0;
				break;
			case 11: // Não entre ... e ...
				if (colref.wda003Tipocoluna === "D") {
					aplicaFormatacoes = !(dateFunctions.isAfterOrEqual(valueRef,wda011Valor) && dateFunctions.isBeforeOrEqual(valueRef,wda011Valorfim));
				} else {
					aplicaFormatacoes = !(valueRef >= wda011Valor && valueRef <= wda011Valorfim);
				}
				break;
			case 12: // Fora da lista
				aplicaFormatacoes = !String(wda011Valor)?.split(",").some((x) => x === String(valueRef).toUpperCase());
				break;
			case 13: // Não é nulo
				aplicaFormatacoes = !!valueRef;
				break;
			case 14: // Não contém
				aplicaFormatacoes = !(String(valueRef).toUpperCase().indexOf(wda011Valor as string) >= 0);
				break;
			case 15: // Inicia com
				aplicaFormatacoes = String(valueRef).toUpperCase().startsWith(wda011Valor as string);
				break;
			case 16: // Termina com
				aplicaFormatacoes = String(valueRef).toUpperCase().endsWith(wda011Valor as string);
				break;
			default: 
				break;
			}

			valor = data[column.wda003Nomecoluna];
			valor = valor || valor === 0 ? convertValue(valor?.toString(),column.wda003Tipocoluna) : "";
			valorString = valor?.toString();
		    if (column.wda003Tipocoluna === "D" && valor) 
			    valorString = formatDate(new Date(valor),currentLanguage);
                
			if (aplicaFormatacoes) {
				if (rule.wda011Avancado) {
					valorString = rule.wda011Avancado.replaceAll("{{valor}}", valorString);
					columns.forEach((col) => {
						let valorTemp = data[col.wda003Nomecoluna];
						valorTemp = valorTemp ? valorTemp.toString() : "";
						if (col.wda003Tipocoluna === "D") {
							valorTemp = formatDate(new Date(valorTemp as string),currentLanguage);
						}
						valorString = valorString.replaceAll(`{{${col.wda003Nomecoluna}}}`, valorTemp);
					});
				} 
                
				if (rule.wda011Tamanhofonte) {
					style += `font-size: ${rule.wda011Tamanhofonte}px;`;
				}
				if (rule.wda011Negrito) {
					style += "font-weight: 700;";
				}
				if (rule.wda011Italico) {
					style += "font-style: italic;";
				}
				if (rule.wda011Corfonte) {
					style += `color:${rule.wda011Corfonte};`;
				}
			}
		}
        
	});

	return {style,content:valorString};
};


export default resolveRules;
